import { Reorder, useDragControls, motion } from "framer-motion";
import { PropsWithChildren } from "react";

interface Props<T> extends PropsWithChildren {
    value: T;
}

const ReorderItem = <T extends unknown>(props: Props<T>) => {
    const controls = useDragControls();

    return ( 
        <Reorder.Item className="mb-2" value={props.value} dragListener={false} dragControls={controls}>
            <div className="bg-white border rounded p-2">
                <div className="d-flex justify-content-end mb-1">
                    <motion.button 
                        type="button"
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        onPointerDown={(e) => controls.start(e)} 
                        className="btn btn-sm btn-primary"
                    >
                        <i className="bi bi-grid-fill"></i>
                    </motion.button>
                </div>

                {props.children}
            </div>
        </Reorder.Item>
     );
};
 
export default ReorderItem;